export enum ReportInputMode {
  Create
  // Update,
  // Delete
}
